module.exports = __webpack_public_path__ + "img/icon_main_about.b0078ac7.svg";